// config submodule

export function setBBPracticeConfig() {
  window.BBPracticeConfig.setLanguage(navigator.language);
}
